export const NEWBUILDING_ADFOX_SITE_JK_DESKTOP = 'newbuilding_adfox_site_jk_desktop';

export const NEWBUILDING_TRUST_AND_SAFETY = 'newbuilding_trust_safety_desktop';
